import { Component } from '@angular/core';

@Component({
  selector: 'app-help-center',
  standalone: true,
  imports: [],
  templateUrl: './help-center.component.html',
  styles: ``
})
export class HelpCenterComponent {

}
